<template>
    <PersonalInfoPolicy20250422Content />
</template>

<script>
import PersonalInfoPolicy20250422Content from '@/views/policy/common/PersonalInfoPolicy20250422Content.vue';

export default {
    name: 'PrivacyPolicy20250422',
    components: {
        PersonalInfoPolicy20250422Content,
    },
};
</script>
